import styles from './text-area-auto-size.module.scss';
import { TextareaAutosize } from '@mui/material';
import FormControl from '../form-control/form-control';

/* eslint-disable-next-line */
export interface TextAreaAutoSizeProps {
  placeholder?: string,
  minRows?: number
  value?: string,
  label?: string,
  fullWidth?: boolean,
  // onBlur?: (event: any) => void,
  onChange?: (event: any) => void
}

export function TextAreaAutoSize(props: TextAreaAutoSizeProps) {
  return (
    <FormControl
      label={props.label}
      fullWidth={props.fullWidth}>
      <TextareaAutosize
        minRows={props.minRows}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange} />
    </FormControl>
  );
}

export default TextAreaAutoSize;